mutation RequireTrainingRetake($moduleId: ID!, $dueOn: ISO8601Date) {
  requireTrainingRetake(input: { moduleId: $moduleId, dueOn: $dueOn }) {
    assignedCount
  }
}
